<template>
  <div class="edit-studio-container">

    <main class="tab-content">

      <h2 class="item text-secondary">FOS form content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Country code:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.country_code" />
        </div>
        <div class="field-sec">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_form_title" />
        </div>
        <div class="field-sec">
          <label>First name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Last name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_last_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Studio name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.studio_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Contact name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.contact_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Email placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_email_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Phone placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_phone_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Question:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.question" />
        </div>
        <div class="field-sec">
          <label class=""> Answers:</label>
          <input v-for="item, i in fit20.blockToEdit.answers" type="text" class="form-control"
            v-model="fit20.blockToEdit.answers[i]" />
        </div>
        <div class="field-sec">
          <label class="">Contact permission question:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.contact_permission_question" />
        </div>
        <div class="field-sec">
          <label class="">Check box text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.contact_permission" />
        </div>
        <div class="field-sec">
          <label class="">Submit button:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.send_btn_text" />
        </div>
        <div class="field-sec">
          <label class="">Thank you page:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.thank_you_page" />
        </div>
      </form>
      <h2 class="item text-secondary">Error messages:</h2>
      <form class="form-container admin-studio-tab-pane fade show active" id="error">
        <div class="field-sec">
          <label class="">General error message:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_all" />
        </div>
        <div class="field-sec">
          <label class="">Invalid email error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_email2" />
        </div>
        <div class="field-sec">
          <label class="">Invalid phone error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_phone2" />
        </div>
        <div class="field-sec">
          <label class="">Permission error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_permission" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div class="kmt" id="FO_spacial">
        <div class="right-side-kmt-form">
          <h2 id="kmt_form_title_fos" class="kmt-form-title">{{ fit20.blockToEdit.kmt_form_title }}</h2>
          <h3 class="kmt-form-subtitle"></h3>
          <form class="" id="form_field">
            <div class="kmt-error-container">
              <div class="kmt-error hidden" id="kmt_error"></div>
            </div>
            <ul class="kmt-fields">
              <li>
                <div>
                  <input id="kmt_first_name" type="text" maxlength="255"
                    :placeholder="fit20.blockToEdit.kmt_name_placeholder" />
                </div>
              </li>
              <li>
                <div>
                  <input id="kmt_last_name" type="text" maxlength="255"
                    :placeholder="fit20.blockToEdit.kmt_last_name_placeholder" />
                </div>
              </li>
              <li>
                <div>
                  <input id="kmt_studio_name" type="text" maxlength="255"
                    :placeholder="fit20.blockToEdit.studio_name_placeholder" />
                </div>
              </li>
              <li>
                <div>
                  <input id="fos_contact_name" type="text" maxlength="255" value=""
                    :placeholder="fit20.blockToEdit.contact_name_placeholder" />
                </div>
              </li>
              <li>
                <div>
                  <input id="kmt_email" type="email" maxlength="255" value=""
                    :placeholder="fit20.blockToEdit.kmt_email_placeholder" />
                </div>
              </li>
              <li>
                <div>
                  <div>
                    <input id="kmt_phone" type="text" :placeholder="fit20.blockToEdit.kmt_phone_placeholder" />
                  </div>
                </div>
              </li>
              <li>
                <div class="not-fixed fos-text">
                  <div class="not-fixed fos-text"></div>
                </div>
              </li>
              <li>
                <div class="not-fixed fos-text">
                  <div class="not-fixed fos-text">
                    <span id="fos_question">{{ fit20.blockToEdit.question }}</span>
                    <select id="fos_answers" type="text" value="">
                      <option v-for="item, i in fit20.blockToEdit.answers">{{ item }}</option>
                    </select>
                  </div>
                </div>
              </li>
              <li class="fos-checkbox">
                <div id="permission_question" class="not-fixed fos-text">{{
                  fit20.blockToEdit.contact_permission_question }}</div>
                <input type="checkbox" id="permission" /><span id="permission_text" class="not-fixed fos-text">{{
                  fit20.blockToEdit.contact_permission }}</span>
              </li>
            </ul>
            <div class="zcwf_row not-fixed fos-text">
              <div class="reCAPTCHA-text">
                This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service
                apply.
              </div>
              <div class="btn-container">
                <div class="btn-div">
                  <button data-sitekey="6Lfwco0iAAAAABguhve-qhu-bCyYNTiY8qK2KgTu" data-callback="onSubmit" type="button"
                    id="form_submit_fos" class="form-submit" onclick="">{{ fit20.blockToEdit.send_btn_text }}</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>

  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';



export default {
  name: 'FosForm',
  components: {

  },
  props: ["selectTab", "admin_fit20", "fit20", "admin", "saveBlock"],
  data() {
    return {
    };
  },
  methods: {
    isValidEmail: function (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    cancelEditing: function () {
      if (!isEqual(this.fit20.blockToEdit, this.fit20.originalBlock)) {
        this.fit20.blockToEdit = {
          ...this.fit20.originalBlock
        };
        this.updated = true;
      }
    },
  },
  watch: {
    "fit20.blockToEdit": {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        if (isEqual(newVal, this.fit20.originalBlock)) {
          $('#cancelUser').removeClass("cancel-btn-active");
          $('#saveUser').removeClass("save-btn-active");
          $('#cancelUser2').removeClass("cancel-btn-active");
          $('#saveUser2').removeClass("save-btn-active");
        } else {
          if (!$('#cancelUser').hasClass('cancel-btn-active')) {
            $('#cancelUser').addClass("cancel-btn-active");
            $('#saveUser').addClass("save-btn-active");
            $('#cancelUser2').addClass("cancel-btn-active");
            $('#saveUser2').addClass("save-btn-active");
          }
        }
      }
    },
  }
};
</script>

<style scoped>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* fit20 fos form style */
.kmt {
  width: 100%;
  min-height: 600px;
  display: flex;
  background: url('https://www.fit20.com/files/images/Global/Global Grids/FIT02680\ -\ Headers\ website\ iconen\ patronen\ DNA\ -\ fit20\ franchise.png');
}

.kmt section {
  width: 80% !important;
  max-width: 1500px !important;
  margin: auto !important;
  font-family: sans-serif !important;
  background-color: white !important;
  padding: 20px !important;
  border-radius: 20px !important;
}

#fos_answers {
  width: 20%;
  border: none;
  border: solid 1px #5e7fb133;
  /* height: 30px; */
  margin-left: 20px;
  border-radius: 5px;
  font-size: 15px;
}

.kmt select {
  padding-block-start: 0px !important;
  padding-block-end: 0px !important;
}

.kmt .kmt-form-subtitle {
  text-align: center;
  color: #616365 !important;
  margin-bottom: 15px;
}

.fos-text {
  font-size: 17px;
}

.kmt h2 {
  margin-top: 0px !important;
  color: #92d400 !important;
}

.kmt ul {
  padding: 0 !important;
}

.kmt .right-side-kmt-form {
  width: 60% !important;
  max-width: 1500px !important;
  margin: auto !important;
  font-family: sans-serif !important;
  background-color: white !important;
  padding: 20px !important;
  border-radius: 20px !important;
}

.kmt .kmt-form-title {
  text-align: center !important;
  color: #92d400 !important;
  font-family: 'VAG Rounded Std light', Verdana, Geneva, Tahoma, sans-serif !important;
}

.kmt li {
  padding: 0 !important;
  list-style: none !important;
  line-height: normal !important;
}

#crmWebToEntityForm.zcwf_lblTopBottom {
  width: 100% !important;
}

.kmt .kmt-fields {
  width: 100% !important;
  display: flex !important;
  justify-content: space-around !important;
  flex-wrap: wrap !important;
  padding-left: 10px !important;
  color: #616365 !important;
}

.kmt .kmt-fields li {
  width: 45% !important;
  margin-bottom: 15px !important;
}

.kmt .kmt-fields input {
  width: 100% !important;
  height: 40px !important;
}

.kmt .kmt-fields li:last-child,
.kmt .kmt-fields li:nth-last-child(2) {
  width: 95% !important;
}

.kmt .kmt-fields li:last-child input:last-child {
  width: 73% !important;
}

.kmt .kmt-fields input,
.kmt textarea {
  border: solid 1px #5e7fb133 !important;
  border-radius: 5px !important;
  padding: 3px 0px 3px 10px !important;
  outline: none !important;
  font-size: 14px !important;
}

.kmt textarea {
  width: 100% !important;
  height: 50px !important;
}

.kmt .reCAPTCHA-text {
  text-align: center !important;
  font-size: 11px !important;
  padding: 10px 0 15px 10px !important;
  color: #616365 !important;
}

.kmt .form-submit {
  cursor: pointer !important;
  color: #ffffff !important;
  background-color: #e5007d !important;
  border: solid 1px #e5007d !important;
  font-size: 15px !important;
  border-radius: 20px !important;
  padding: 7px 30px !important;
}

.kmt .form-submit:hover {
  background-color: transparent !important;
  color: #e5007d !important;
  transition: all 0.3s !important;
}

.btn-container {
  width: 100%;
  text-align: center !important;
}

.btn-div {
  display: inline-block !important;
  z-index: 1 !important;
  position: relative;
  margin: 0 auto !important;
  border-radius: 15px !important;
}

.btn-div:after {
  transition: all 0.3s !important;
  content: '' !important;
  background: #ffffff !important;
  border-radius: 15px !important;
  width: 0% !important;
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  height: 100% !important;
  z-index: -1 !important;
}

.btn-div:hover:after {
  width: 100% !important;
}

.hidden {
  display: none !important;
}

.kmt-error {
  border: 1px solid red !important;
  border-radius: 10px !important;
  background-color: rgb(255, 215, 215) !important;
  text-align: center !important;
  font-size: 14px !important;
}

.display-none {
  display: none !important;
}

.kmt .selected {
  transition: all 0.1s !important;
  border: 2px solid #009fe3 !important;
}

.kmt .fos-checkbox input {
  height: fit-content !important;
  width: fit-content !important;
  margin-top: 15px;
  margin-right: 10px;
}

@media only screen and (max-width: 900px) {
  #fos_answers {
    font-size: 11px;
  }

  .fos-text {
    font-size: 12px;
  }

  .kmt section {
    width: 90% !important;
    padding: 10px !important;
  }

  .kmt h2 {
    margin-top: 0px !important;
  }

  .kmt ul {
    padding: 0 !important;
  }

  .kmt .right-side-kmt-form {
    width: 80% !important;
  }

  .kmt .kmt-fields {
    padding-left: 5px !important;
  }

  .kmt .kmt-fields input,
  .kmt .kmt-fields textarea,
  .kmt .kmt-fields label {
    font-size: 10px !important;
  }

  .kmt .kmt-fields li {
    width: 95% !important;
    margin-bottom: 5px !important;
  }

  .kmt .kmt-fields li:last-child {
    width: 95% !important;
  }

  .kmt .kmt-fields li:last-child input:last-child {
    width: 95% !important;
  }

  .kmt .reCAPTCHA-text {
    font-size: 9px !important;
    padding: 5px 0 5px 10px !important;
  }

  .kmt .form-submit {
    font-size: 12px !important;
    padding: 5px 20px !important;
  }

  .hidden {
    display: none !important;
  }

  .kmt-error {
    border: 1px solid red !important;
    border-radius: 10px !important;
    background-color: rgb(255, 215, 215) !important;
    text-align: center !important;
    font-size: 10px !important;
  }
}
</style>
